/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ExportClearanceCaseResponseJson } from './export-clearance-case-response-json';
import { ExportClearanceCaseResult } from '../results/export-clearance-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ExportClearanceCaseResponse extends ResponseWithErrorGeneric<ExportClearanceCaseResponseJson, ExportClearanceCaseResult> implements IResponseWithErrorGeneric<ExportClearanceCaseResult> {


  //<custom-body>
  constructor(response: HttpResponse<ExportClearanceCaseResponse>) {
    super(response, ExportClearanceCaseResult.Error);
  }
  //</custom-body>
}
